<template>
  <v-container class="px-0">
    <v-form ref="lotesPendentesFilterForm">
      <v-row  class="px-0">
        <v-col cols="12" sm="6" md="2">
          <label>Data entre</label>
          <v-menu
            ref="dtI"
            v-model="dtI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateIFormatted"
                dense
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                :rules="[formRules.typeDateFormated]"
                @blur="dateI = parseDate(dateIFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateI" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <label>até</label>
          <v-menu
            ref="dtF"
            v-model="dtF"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFFormatted"
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                :rules="[formRules.typeDateFormated]"
                @blur="dateF = parseDate(dateFFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="dateF" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer/>
<v-col class="py-0" cols="12" sm="6" md="3" v-if="isComplementar">
            <v-checkbox
            class="pa-0 ma-0 pt-4"
             style="font-size: 12px !important"
            v-model="formData.abertos"
            small
            label="Apenas cronogramas com complementação em aberto."
            hide-details
          ></v-checkbox>
        </v-col>
         <v-col class="py-0" cols="12" sm="6" md="3" v-else>
           <v-checkbox
           style="font-size: 14px !important"
            class="pa-0 ma-0 pt-4"
            small
            v-model="formData.complementar"
            label="Apenas cronogramas complementares"
            hide-details
          ></v-checkbox>
         </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="formData.prestador_id"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="prestadoresFilter.length==1"
              :search-input.sync="searchInput"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'prestador_id')" :class="formData.prestador_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.prest_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.prestador_id.length>1? 'max-width:30%':'max-width:100%'">{{
              data.item.prest_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
 <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Operadoras</label>
            <v-autocomplete
              v-model="formData.operadora_ans_id"
              :items="operadorasFilter"
              item-value="id"
              item-text="oper_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="operadorasFilter.length==1"
              :search-input.sync="searchInput"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'operadora_ans_id')" :class="formData.operadora_ans_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.operadora_ans_id.length>1? 'max-width:30%':'max-width:100%'">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadora_ans_id.length == 3
                  ? formData.operadora_ans_id.length - 2 + " outro"
                  : formData.operadora_ans_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
        <v-col class="py-0" cols="12" sm="6" md="2">
          <label>Responsável</label>
          <v-select
            v-model="formData.owner_id"
            :items="responsaveisFilter"
            item-value="Id"
            item-text="UserName"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col class="py-0" cols="12" sm="6" md="2" v-if="!isComplementar">
          <label>Status</label>
          <v-select
            v-model="formData.card_name"
            :items="statusFilter"
            item-value="id"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
          >
            <template v-slot:item="data">
              <template v-if="(typeof data.item !=='object')">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-avatar size="20" :color="data.item.color" v-if="data.item.color">
                </v-list-item-avatar>
              </template>
            </template>
          </v-select>
        </v-col>
        <v-btn
          class="mt-5"
          height="31px"
          small
          depressed
          color="primary"
          @click="validateFilter('documentsFilterForm')"
        >Filtrar</v-btn>
        <v-btn
          class="mt-5 ml-4"
          height="31px"
          small
          depressed
          outlined
          color="primary"
          @click="clearFilters()"
        >Limpar Filtros</v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex'
export default {
  directives: {
    mask
    },
  beforeCreate(){
    this.monName = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]
  },
  data(){
    return {
      filter:{},
      cookieFilter: null,
      prest: null,
      formData: {
        abertos: null,
        complementar: null,
        prestador_id: [],
        operadora_ans_id: [],
        owner_id: null,
        card_name: null,
        dt_faturamento_fim: null,
        dt_faturamento_ini: null,
        modulo_operadora: "faturamento"
      },
      dateF: null,
      dateFFormatted: null,
      dateI:null,
      dateIFormatted: null,
      dtI: false,
      dtF: false,
      prestadoresFilter:[],
      operadorasFilter:[],
      responsaveisFilter: [],
      monName: [],
      statusFilter: [
         {
        id: null,
        descricao: 'Selecione',
        color: null,
         },
      {
        id: "Concluidos",
        descricao: `Concluído em ${this.monName[(new Date).getMonth()]}/${(new Date).getFullYear().toString()}`,
        color: "#32B88B",
      },{
        id: "Fechados",
        descricao: "Concluído",
        color: "#32B88B",
      },{
        id: "AConcluir",
        descricao: "Aguardando conclusão",
        color: "#B2B842",
      },{
        id: "Processando",
        descricao: "Em processamento (envio automático)",
        color: "#4A4A4A",
      },{
        id: "ProcessandoManual",
        descricao: "Em processamento (envio manual)",
        color: "#4A4A4A",
      },{
        id: "NaoIniciados",
        descricao: "Não iniciado",
        color: "#979797",
      },{
        id: "Critica",
        descricao: "Com crítica",
        color: "#D0021B",
      },{
        id: "AEnvio",
        descricao: "Aguardando transmissão",
        color: "#FC5F17",
      },{
        id: "Atrasados",
        descricao: "Em Atraso",
        color: "#FFA500",
      }],
      searchInput: null
    }
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules
    }),
  },
  methods: {
    clearFilters(){
      this.dateFFormatted = null;
      this.dateIFormatted = null;
      this.formData.dt_faturamento_fim = null;
      this.formData.dt_faturamento_ini = null;
      this.formData.card_name = null;
      this.formData.owner_id = null;
      this.formData.modulo_operadora = "faturamento"
      if (this.prestadoresFilter.length>1) {
        this.formData.prestador_id = [];
      }
      if (this.operadorasFilter.length>1) {
        this.formData.operadora_ans_id = [];
      }
      this.updateFilter(this.formData, 1, true)
      this.$refs.lotesPendentesFilterForm.resetValidation()
    },
    changePrestador(){
      let opts = {
        owner_id: null,
        modulo_operadora: "recebiveis",
        prestador_ids: this.formData.prestador_id
      }
      this.getResponsaveis(opts)
      this.getOperadoras(opts)
    },
    toggleAutocomplete(item, campo) {
      this.searchInput = null
          let index = this.formData[campo].indexOf(item.id)
          //  index > -1  está excluindo a operadora
          if (index > -1) {
            this.formData[campo].splice(index, 1)
          } else {
            //  index < 0  está adicionando a operadora
              this.formData[campo].push(item.id)
          }
            this.$nextTick()
            return
        },
    updateListaFilter(lista, nomedaLista, nomedocampo, objSelecione){
        this[nomedaLista] = Array.from(lista)
        let param = nomedaLista == 'responsaveisFilter'? 'Id': 'id'
            if(lista.length==1){
                if(nomedaLista != "prestadoresFilter" &&  nomedaLista != "operadorasFilter" ){
                    this.formData[nomedocampo] = lista[0][param] 
                }
                else {
                    this.formData[nomedocampo] = []
                    this.formData[nomedocampo].push(lista[0][param])
                }
            } else {
                if(nomedaLista != "prestadoresFilter" &&  nomedaLista != "operadorasFilter" ){
                    this[nomedaLista].unshift(objSelecione)
                }
                if(nomedaLista != "prestadoresFilter" &&  nomedaLista != "operadorasFilter" ){
                    let ind = lista.findIndex(el=> el[param] == this.formData[nomedocampo] )
                    this.formData[nomedocampo] = ind > -1? lista[ind][param]  : null
                }
                else {
                    this.formData[nomedocampo] = (this.formData[nomedocampo] && this.formData[nomedocampo].length)? this.formData[nomedocampo].filter(el => this[nomedaLista].findIndex(item=> item.id == el)>-1 ) : []
                }
            }
        },
    validateFilter(){
      if(this.$refs.lotesPendentesFilterForm.validate()){
        if(!this.formData.dt_faturamento_fim && this.formData.dt_faturamento_ini) {
            this.dateF = this.formData.dt_faturamento_ini
            this.formData.dt_faturamento_fim = this.formData.dt_faturamento_ini
        }
        this.updateFilter(this.formData, 1, false)
      }

    }
  },
  props: {
    controlResponsavel: Boolean,
    formatDate: Function,
    updateFilter: Function,
    getOperadoras: Function,
    getResponsaveis: Function,
    operadoras: Array,
    parseDate: Function,
    prestadores: Array,
    responsaveis: Array,
    userData: Object,
    prestadorId: Function,
    isComplementar: { type: Boolean, default: false }
  },
 async mounted() {
    this.updateListaFilter(this.prestadores, 'prestadoresFilter', 'prestador_id', {id: null, prest_nome: "Selecione"})
    this.updateListaFilter(this.operadoras, 'operadorasFilter', 'operadora_ans_id', {id: null, oper_nome: "Selecione"})
    this.updateListaFilter(this.responsaveis, 'responsaveisFilter', 'owner_id', {Id: null, UserName: "Selecione"})

    let filtroExterno = null
    await this.$store.dispatch("recebiveis/getFilter",'lotesPendentes',  { root: true }).then(
        resp => filtroExterno = resp
    )
    if(filtroExterno){ 
        this.formData = Object.assign(this.formData,{...filtroExterno})
        this.dateIFormatted = this.formatDate(this.formData.dt_faturamento_ini)
        this.dateFFormatted = this.formatDate(this.formData.dt_faturamento_fim)
        if(!this.formData.prestador_id && this.prestadores.length==1){
          this.formData.prestador_id = this.prestadoresFilter[0].id
        }
        this.updateFilter(this.formData, 1, false)
    } 
  },
  watch: {
    dateF(val){
      if (!val) {
        this.dateFFormatted = null
      } else {
        if (!!this.dateI && Date.parse(this.dateI) > Date.parse(val)){
          this.dateI = val
        }
        this.dateFFormatted = this.formatDate(val)
      }
    },
    dateFFormatted(val){
      this.formData.dt_faturamento_fim = this.parseDate(val)
    },
    dateI(val){
      if (!val) {
        this.dateIFormatted = null
      } else {
        if (!!this.dateF && Date.parse(this.dateF) < Date.parse(val)){
          this.dateF = val
        }
        this.dateIFormatted = this.formatDate(val)
      }
    },
    dateIFormatted(val){
      this.formData.dt_faturamento_ini = this.parseDate(val)
    },
    prestadores:{
      deep: true,
      handler(val){
         this.updateListaFilter(val, 'prestadoresFilter', 'prestador_id', {id: null, prest_nome: "Selecione"})
      }
    },
    operadoras:{
      deep: true,
      handler(val){
        this.updateListaFilter(val, 'operadorasFilter', 'operadora_ans_id', {id: null, oper_nome: "Selecione"})
      }
    },
    responsaveis:{
      deep: true,
      handler(val){
        this.updateListaFilter(val, 'responsaveisFilter', 'owner_id', {Id: null, UserName: "Selecione"})
      }
    }
  },
};
</script>
